import { useEffect, useState } from 'react';

/**
 * A phone, held either way (V2 D85): a touch screen narrower than a tablet,
 * or one too short to be a tablet (an iPhone on its side is wider than
 * 768px but under 500px tall). A narrow desktop window does not count; it
 * has a mouse and keeps the full scheduler.
 */
export const PHONE_QUERY = '(pointer: coarse) and (max-width: 767px), (pointer: coarse) and (max-height: 500px)';

export function isPhoneNow(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(PHONE_QUERY).matches;
}

export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(isPhoneNow);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(PHONE_QUERY);
    const onChange = () => setPhone(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return phone;
}
